export const timeformat = (hour: number) => {
  if (hour <= 24) return `${hour.toFixed(0)} hours`;
  else if (hour <= 24) return `${hour.toFixed(0)} hours`;
  else if (hour <= 24 * 60) return `${(hour / 24).toFixed(0)} days`;
  else if (hour <= 24 * 30 * 24) return `${(hour / (24 * 30)).toFixed(0)} months`;
  else return `${(hour / (24 * 30 * 12)).toFixed(0)} years`;
};
